import { View, Text, StyleSheet } from "react-native";
import { LinearGradient } from "expo-linear-gradient";
import { useTranslation } from "react-i18next";

/**
 * LoginLeftSidebar component
 * Reusable gradient sidebar with skeleton cards for auth pages
 */
const LoginLeftSidebar = () => {
  const { t } = useTranslation();

  // Skeleton card component - static, no animation
  const SkeletonCard = ({ style, type }) => {
    if (type === "first") {
      return (
        <View style={[styles.skeletonCard, style]}>
          <View
            style={[
              styles.skeletonLine,
              { width: "60%", backgroundColor: "rgba(227, 225, 225, 0.4)" },
            ]}
          />
          <View style={styles.skeletonCircle} />
          <View style={[styles.skeletonLine, { width: "100%" }]} />
        </View>
      );
    }

    if (type === "second") {
      return (
        <View style={[styles.skeletonCard, style]}>
          {/* First row */}
          <View style={styles.skeletonRow}>
            <View
              style={[
                styles.skeletonDot,
                { backgroundColor: "rgba(227, 225, 225, 0.4)" },
              ]}
            />
            <View style={[styles.skeletonLine, { width: "auto", flex: 1 }]} />
            <View style={[styles.skeletonLine, { width: "auto", flex: 3 }]} />
            <View style={[styles.skeletonLine, { width: "auto", flex: 1 }]} />
          </View>

          {/* Separator */}
          <View style={styles.skeletonSeparator} />

          {/* Second row (same as first) */}
          <View style={styles.skeletonRow}>
            <View
              style={[
                styles.skeletonDot,
                { backgroundColor: "rgba(227, 225, 225, 0.4)" },
              ]}
            />
            <View style={[styles.skeletonLine, { width: "auto", flex: 1 }]} />
            <View style={[styles.skeletonLine, { width: "auto", flex: 3 }]} />
            <View style={[styles.skeletonLine, { width: "auto", flex: 1 }]} />
          </View>
        </View>
      );
    }

    if (type === "third") {
      return (
        <View style={[styles.skeletonCard, style]}>
          <View style={styles.skeletonRow}>
            <View style={[styles.skeletonLine, { width: "auto", flex: 1 }]} />
            <View style={[styles.skeletonLine, { width: "auto", flex: 1 }]} />
            <View style={[styles.skeletonLine, { width: "auto", flex: 1 }]} />
          </View>
          <View style={styles.skeletonRow}>
            <View style={[styles.skeletonLine, { width: "auto", flex: 1 }]} />
            <View style={[styles.skeletonLine, { width: "auto", flex: 1 }]} />
            <View style={[styles.skeletonLine, { width: "auto", flex: 1 }]} />
          </View>
          <View
            style={[
              styles.skeletonLine,
              {
                width: "100%",
                backgroundColor: "rgba(227, 225, 225, 0.4)",
                marginTop: 4,
              },
            ]}
          />
        </View>
      );
    }

    return null;
  };

  return (
    <LinearGradient
      colors={["#204756", "#204756", "#306A7C"]}
      locations={[0, 0.7, 1]}
      style={styles.sidebar}
    >
      <View style={styles.sidebarContent}>
        {/* Header text */}
        <Text style={styles.headerText}>{t("replaceSpreadsheets-string")}</Text>

        {/* Three skeleton cards */}
        <View style={styles.cardsContainer}>
          <SkeletonCard style={styles.leftCard} type="first" />
          <SkeletonCard style={styles.centerCard} type="second" />
          <SkeletonCard style={styles.rightCard} type="third" />
        </View>
      </View>
    </LinearGradient>
  );
};

const styles = StyleSheet.create({
  sidebar: {
    width: 510,
    minHeight: "100vh",
    alignItems: "center",
    justifyContent: "center",
  },
  sidebarContent: {
    flex: 1,
    padding: 48,
    justifyContent: "center",
  },
  headerText: {
    fontSize: 24,
    fontWeight: "600",
    color: "#FFFFFF",
    lineHeight: 40,
    marginBottom: 32,
  },
  cardsContainer: {
    justifyContent: "space-between",
    alignItems: "center",
    gap: 24,
    marginBottom: 36,
  },
  skeletonCard: {
    backgroundColor: "rgba(255, 255, 255, 0.48)",
    gap: 8,
    borderRadius: 12,
    padding: 16,
  },
  leftCard: {
    alignSelf: "flex-start",
    width: "45%",
  },
  centerCard: {
    alignSelf: "stretch",
  },
  rightCard: {
    width: "55%",
    alignSelf: "flex-end",
  },
  skeletonLine: {
    width: "100%",
    height: 10,
    backgroundColor: "rgba(255, 255, 255, 0.15)",
    borderRadius: 6,
  },
  skeletonRow: {
    flexDirection: "row",
    alignItems: "center",
    gap: 8,
    width: "100%",
  },
  skeletonDot: {
    width: 10,
    height: 10,
    backgroundColor: "rgba(255, 255, 255, 0.15)",
    borderRadius: 5,
  },
  skeletonSeparator: {
    width: "100%",
    height: 1,
    backgroundColor: "rgba(255, 255, 255, 0.15)",
    marginVertical: 4,
  },
  skeletonCircle: {
    width: 24,
    height: 24,
    backgroundColor: "rgba(255, 255, 255, 0.15)",
    borderRadius: 30,
  },
});

export default LoginLeftSidebar;
